import { Chakra } from "@airhelp/react-ui-components";
import Grid from "modules/common/components/Grid";
import { TrustpilotSummary } from "./TrustpilotSummary";
import { ReviewSlider } from "./ReviewSlider";

const { Box, Heading, Flex } = Chakra;

interface TrustpilotSectionProps {
  heading: string;
}

export const TrustpilotSection = ({ heading }: TrustpilotSectionProps) => (
  <>
    <Grid mb={{ base: 10, md: 12 }}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }} data-testid="trustpilot-section">
        <TrustpilotSummary pb={4} />
        <Flex justify="space-between" flexDir={{ base: "column", md: "row" }} mb={{ base: 0, md: 4 }}>
          <Heading data-testid="trustpilot-header" variant="h2" as="h2" letterSpacing="normal" mb={{ base: 8, md: 0 }}>
            {heading}
          </Heading>
          <Flex id="trustpilot-slider-nav" align="end" justify={{ base: "center", md: "initial" }} />
        </Flex>
      </Box>
    </Grid>
    <Box w="full" overflowX="hidden">
      <Box w="full" maxWidth="1202px" px={4} mx="auto">
        <ReviewSlider />
      </Box>
    </Box>
  </>
);
